import React from "react";
import { 
  Modal, 
  Button, 
  Space, 
  Typography,
  Alert,
} from "@pankod/refine-antd";
import { IWorkPlan } from "interfaces/work-plan.interface";

const { Text } = Typography;

interface WorkPlanFinishModalProps {
  visible: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  workPlan?: IWorkPlan;
  isLoading?: boolean;
}

export const WorkPlanFinishModal: React.FC<WorkPlanFinishModalProps> = ({
  visible,
  onCancel,
  onConfirm,
  workPlan,
  isLoading = false,
}) => {
  return (
    <Modal
      title="Finalizar Plan de Trabajo"
      visible={visible}
      onCancel={onCancel}
      width={500}
      footer={null}
      destroyOnClose
    >
      {workPlan && (
        <div>
          <Alert
            message="Confirmar Finalización"
            description="¿Estás seguro de que deseas finalizar este plan de trabajo? Esta acción no se puede deshacer."
            type="warning"
            showIcon
            style={{ marginBottom: 24 }}
          />

          <div style={{ marginBottom: 16 }}>
            <Text strong>Plan de Trabajo:</Text>
            <div style={{ marginTop: 8, padding: 12, backgroundColor: '#f5f5f5', borderRadius: 4 }}>
              <div><Text strong>ID:</Text> {workPlan.id}</div>
              <div><Text strong>Objetivo:</Text> {workPlan.strategy}</div>
              <div><Text strong>Status actual:</Text> COMPLETADA</div>
            </div>
          </div>

          <Alert
            message="Nota"
            description="Una vez finalizado, el plan de trabajo se marcará como FINALIZADA y no podrá ser modificado."
            type="info"
            showIcon
            style={{ marginBottom: 24 }}
          />

          <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
            <Button onClick={onCancel}>
              Cancelar
            </Button>
            <Button 
              type="primary" 
              danger
              onClick={onConfirm}
              loading={isLoading}
            >
              Finalizar Plan
            </Button>
          </Space>
        </div>
      )}
    </Modal>
  );
};
